import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../../utils/errors.js';
import { Button, Modal, TemplateSelect } from '../../index.js';
const CopyModal = (props) => {
    const lang = useSelector((s) => s.lang);
    // Every published language variant of the chosen template is copied
    const [sourceTemplate, setSourceTemplate] = useState(null);
    const [sourceVariants, setSourceVariants] = useState([]);
    const isOtherTemplate = useCallback((template) => template.templateId !== props.templateId, [props.templateId]);
    const copyMutation = useMutation(async () => {
        for (const template of sourceVariants) {
            await templatesAPI.saveDraft({
                ...props.template,
                public: undefined,
                html: template.html,
                intent: template.intent,
                subject: template.subject || '\n',
                lang: template.lang,
                templateTheme: template.templateTheme,
                isForAlternativeContact: template.isForAlternativeContact,
                fileName: template.fileName,
                text: template.text,
                setup: template.setup,
            });
        }
    }, {
        onSuccess: () => {
            props.toggleModal();
            props.loadTemplate();
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.template);
        },
    });
    return (React.createElement(Modal, { header: lang.templates.copyOtherTemplate, onToggle: props.toggleModal },
        React.createElement(TemplateSelect, { templateType: props.template.type, filter: isOtherTemplate, value: sourceTemplate?.templateId ?? null, selectedLang: sourceTemplate?.lang, onChange: (template, variants) => {
                setSourceTemplate(template);
                setSourceVariants(variants);
            } }),
        React.createElement(Button, { disabled: sourceVariants.length === 0, loading: copyMutation.isLoading, onClick: () => copyMutation.mutate() }, lang.templates.copy)));
};
export default CopyModal;
//# sourceMappingURL=CopyTemplateModal.js.map